<!-- ---------------------------------- footer ------------------------ -->
<div class="footer">
    <!-- <div class="container-large"> -->
    <div class="content-footer background-color">
        <div class="container-large">
            <div class="row no-gutter">
                <div [innerHTML]="footer?.col1" class="col-md-4 col-info-left">
                   
                </div>
                <div [innerHTML]="footer?.col2" class="col-md-4 col-info-left">              
                </div>
                <div class="col-md-4 col-info-right">                  
                    <div class="mb-0" [innerHTML]="fanpage"> 
                    </div>

                </div>
                <div  class="col-md-12 text-center text-white">                  
                    <p [innerHTML]="footer?.footer">

                    </p>
                </div>
            </div>
        </div>

    </div>
    <!-- </div> -->
</div>
<!-- ---------------------------------- end footer ------------------------ -->